module.exports = __webpack_public_path__ + "static/media/landing-top-person-dei.f8c0fb0e.png";